export const SERVICES = [
  {
    id: "social-media-marketing",
    icon: "Share2",
    title: "Social Media Marketing",
    description: "Full-funnel social strategy and daily presence management across every major platform.",
    items: ["Instagram", "Facebook", "LinkedIn", "YouTube", "X", "Social strategy", "Community management"],
  },
  {
    id: "content-strategy",
    icon: "Clapperboard",
    title: "Content Strategy & Creation",
    description: "Scroll-stopping content engineered for attention, recall and shares.",
    items: ["Reels", "Videos", "Graphics", "Copywriting", "Brand storytelling", "Campaign concepts"],
  },
  {
    id: "influencer-marketing",
    icon: "Users",
    title: "Influencer Marketing",
    description: "End-to-end creator campaigns, from discovery to measurable performance.",
    items: ["Influencer discovery", "Creator campaigns", "Campaign management", "Negotiation", "Performance tracking"],
  },
  {
    id: "digital-advertising",
    icon: "Target",
    title: "Digital Advertising",
    description: "Performance media buying built around qualified leads and conversions.",
    items: ["Meta Ads", "Google Ads", "YouTube Ads", "Lead generation", "Conversion campaigns", "Retargeting"],
  },
  {
    id: "brand-development",
    icon: "Fingerprint",
    title: "Brand Development",
    description: "Positioning and identity systems that make brands impossible to ignore.",
    items: ["Brand strategy", "Brand identity", "Positioning", "Communication", "Visual identity"],
  },
  {
    id: "campaign-management",
    icon: "Radio",
    title: "Media & Campaign Management",
    description: "Disciplined planning, buying and monitoring for always-on campaigns.",
    items: ["Campaign planning", "Media buying", "Campaign execution", "Performance monitoring"],
  },
  {
    id: "personal-brand-growth",
    icon: "Sparkles",
    title: "Creator & Personal Brand Growth",
    description: "Turn individual expertise into audience, authority and income.",
    items: ["Personal branding", "Content strategy", "Audience growth", "Monetization strategy"],
  },
  {
    id: "analytics-performance",
    icon: "BarChart3",
    title: "Analytics & Performance",
    description: "Transparent reporting that ties every rupee to a result.",
    items: ["Social analytics", "Campaign reports", "Audience insights", "ROI tracking", "Performance optimization"],
  },
];

export const TRUST_CARDS = [
  { icon: "Compass", title: "STRATEGY", description: "Build a clear roadmap for digital growth." },
  { icon: "Lightbulb", title: "CREATIVITY", description: "Turn ideas into memorable content." },
  { icon: "Megaphone", title: "AMPLIFICATION", description: "Take content to the right audience." },
  { icon: "TrendingUp", title: "PERFORMANCE", description: "Measure, optimize and improve results." },
];

export const SOLUTIONS = [
  { icon: "Rocket", title: "STARTUPS", description: "Build visibility and establish your digital identity." },
  { icon: "Building2", title: "SMEs", description: "Generate leads and grow your customer base." },
  { icon: "Landmark", title: "ENTERPRISES", description: "Scale campaigns and strengthen market presence." },
  { icon: "ShoppingBag", title: "E-COMMERCE", description: "Drive traffic, conversions and repeat customers." },
  { icon: "Video", title: "CREATORS", description: "Build audiences, authority and monetization opportunities." },
  { icon: "UserCircle", title: "PERSONAL BRANDS", description: "Turn expertise into digital influence." },
  { icon: "Ticket", title: "EVENTS & ENTERTAINMENT", description: "Create buzz before, during and after the event." },
];

export const PROCESS_STEPS = [
  { number: "01", title: "DISCOVER", description: "Understand your business, audience and objectives." },
  { number: "02", title: "STRATEGIZE", description: "Build the right media and social strategy." },
  { number: "03", title: "CREATE", description: "Develop high-quality content and campaigns." },
  { number: "04", title: "AMPLIFY", description: "Distribute content across relevant channels." },
  { number: "05", title: "OPTIMIZE", description: "Analyze results and continuously improve." },
];

export const WHY_CARDS = [
  { icon: "Crosshair", title: "Strategy First", description: "Every rupee and every post follows a plan built on your business objectives." },
  { icon: "Palette", title: "Creative Thinking", description: "Original ideas and craft that make people stop, watch and remember." },
  { icon: "Database", title: "Data Driven", description: "Decisions backed by analytics, testing and measurable outcomes." },
  { icon: "Layers", title: "Multi-Platform Expertise", description: "Native fluency across Instagram, YouTube, LinkedIn, X and emerging platforms." },
  { icon: "FileSearch", title: "Transparent Reporting", description: "Clear dashboards and honest reporting. You always know what is working." },
  { icon: "Handshake", title: "Long-Term Partnerships", description: "We grow with your brand, quarter after quarter, not campaign to campaign." },
];

export const VALUES = [
  { title: "Creativity", description: "Original thinking that cuts through crowded feeds." },
  { title: "Transparency", description: "Honest reporting, clear pricing, no vanity metrics." },
  { title: "Performance", description: "Every activity ties back to measurable growth." },
  { title: "Innovation", description: "New formats, platforms and tools, tested early." },
  { title: "Partnership", description: "Your goals become our operating plan." },
];

export const COMPANY = {
  name: "TRENDSIGHT MEDIA PRIVATE LIMITED",
  address: "KH. NO. 37/6, 1ST FLOOR, STREET NO. 13/2, NEW-12 BLK-B, KAUSHIK ENCLAVE, LANDMARK NEAR GOVT HOSPITAL, DELHI – 110084",
  phone: "7301880107",
  phoneDisplay: "+91 73018 80107",
  email: "Infopawansingh.ps@gmail.com",
  cin: "U22219DL2022PTC409001",
  gstin: "07AAJCT8776E1ZT",
};

export const MARQUEE_ITEMS = [
  "STRATEGIC MEDIA",
  "SOCIAL GROWTH",
  "INFLUENCER MARKETING",
  "PERFORMANCE AMPLIFICATION",
  "CREATOR ENGINE",
  "BRAND STORYTELLING",
  "DELHI & GLOBAL",
];

export const ECOSYSTEM_FLOW = ["Brand", "Content", "Social Media", "Audience", "Engagement", "Growth"];

export const INSIGHT_CATEGORIES = [
  "Social Media Marketing",
  "Digital Marketing",
  "Influencer Marketing",
  "Branding",
  "Advertising",
  "Content Marketing",
  "Creator Economy",
  "Business Growth",
  "Media Trends",
];

export const CASE_FILTERS = ["All", "Social Media", "Branding", "Influencer", "Advertising", "Content", "Performance"];
